export default {
  name: "PrivacyPolicy",
  created() {
    document.title = "Politique de confidentialité — Application Vitalliance";
    if (this.$route.query.print === "true") {
      this.$nextTick(() => window.print());
    }
  },
  methods: {
    download() {
      const url = window.location.href.split("?")[0] + "?print=true";
      window.open(url, "_blank");
    }
  }
};
